import { actionCopyFr } from "./actionCopy";

export const inviteCopyFr = {
    reviewSetup: "Vérifier la configuration",
    organisationAndContact: "Organisation et contact",
    addPatient: "Ajouter un patient",
    inviteByEmail: "Inviter par e-mail",
    shareQrCode: "Partager le lien / code QR",
    inviteSent: "Invitation envoyée",
    inviteSentTo: (email) => `Invitation envoyée à ${email}`,
    loading: actionCopyFr.loading,
    justAMoment: "Un instant...",
    patientEmailWillReceiveInstructions: (email) => `${email} recevra un e-mail avec les instructions pour commencer.`,
    patientPhoneWillReceiveInstructions: (phone) => `${phone} recevra un SMS avec les instructions pour commencer.`,
    patientWillReceiveInstructions: "Votre patient recevra un e-mail avec les instructions pour commencer.",
    emailAndMobileHint: "Les deux si possible.",
    emailOrPhoneRequired: "(ou téléphone requis)",
    mobileOrEmailRequired: "(ou e-mail requis)",
    diariesAddedInLast7Days: (count) =>
        `Au cours des 7 derniers jours, vous avez ajouté ${count} journaux à Patient Watch.`,
    goToDiary: "Aller au journal",
    inviteAnotherPatient: "Inviter un autre patient",
    whatWasInjected: "Produit injecté",
    clinicians: "Cliniciens",
    referringClinician: "Médecin adresseur",
    injectingClinician: "Médecin réalisant l'injection",
    operatingSurgeon: "Chirurgien opérateur",
    therapist: "Thérapeute",
    injectionMethod: "Méthode d'injection",
    questionnaires: "Questionnaires",
    clinicContact: "Contact du cabinet",
    surgeryDetails: "Informations sur l'opération",
    injectionDetails: "Informations sur l'injection",
    treatmentDetails: "Informations sur le traitement",
    consultationDetails: "Informations sur la consultation",
    consultationName: "Nom de la consultation",
    description: "Description",
    clinician: "Clinicien",
    consultingClinician: "Clinicien consultant",
    consultingClinicianDescription: "Le clinicien qui a réalisé la consultation",
    productDetails: "Informations sur le produit",
    providingClinician: "Clinicien prescripteur",
    providingClinicianDescription: "Le clinicien qui a prescrit, fourni ou configuré le produit",
    usageInstructions: "Instructions d'utilisation",
    editInjectionDetails: "Modifier les informations sur l'injection",
    editInjectionClinicians: "Modifier les cliniciens de l'injection",
    editSurgeryDetails: "Modifier les informations sur l'opération",
    editSurgeryClinicians: "Modifier les cliniciens de l'opération",
    editShockwaveDetails: "Modifier les informations sur les ondes de choc",
    editShockwaveClinicians: "Modifier les cliniciens des ondes de choc",
    editConsultationDetails: "Modifier les informations sur la consultation",
    editConsultingClinician: "Modifier le clinicien consultant",
    editProductDetails: "Modifier les informations sur le produit",
    editProvidingClinician: "Modifier le clinicien prescripteur",
    editClinicContact: "Modifier le contact du cabinet",
    notSet: "Non défini",
    selected: "Sélectionné",
    unknownForm: "Formulaire inconnu",
    unknownSchedule: "Calendrier inconnu",
    noSide: "Aucun côté",
    noOptionSelected: "Aucune option sélectionnée",
    noSubstanceSelected: "Aucune substance sélectionnée",
    noSiteSelected: "Aucun côté ni aucune zone sélectionnés",
    email: "E-mail",
    enterEmail: "Saisir l'adresse e-mail",
    titleOptional: "Titre (facultatif)",
    firstNameOptional: "Prénom (facultatif)",
    lastNameOptional: "Nom (facultatif)",
    mobileNumber: "Mobile",
    firstNamePlaceholder: "p. ex. Sherlock",
    lastNamePlaceholder: "p. ex. Holmes",
    selectPlaceholder: "Sélectionner",
    sendInvite: "Envoyer l'invitation",
    sendingInvite: "Envoi de l'invitation…",
    inviteSentToast: "Invitation envoyée",
    existingPatient: "Patient existant",
    existingPatientAddDiary: "Nous ajouterons ce journal à son compte existant.",
    existingUser: "Utilisateur existant",
    existingUserAddToOrganisation: "Nous l'ajouterons à cette organisation au lieu de créer un nouveau compte.",
    existingSecretary: "Secrétaire existant(e)",
    existingSecretaryAddAsYours: "Nous l'ajouterons comme votre secrétaire pour cette organisation.",
    diaryQuotaBlockedTitle: "Limite de journaux atteinte",
    diaryQuotaUsage: (used: number, limit: number) =>
        `Vous avez utilisé ${used} journaux sur ${limit} pour cette période de facturation.`,
    diaryQuotaBlockedDescription:
        "Passez à une formule supérieure pour inviter davantage de patients avec des journaux.",
    diaryQuotaUpgradeCta: "Choisir une formule",
    diaryQuotaOwnerUnresolved:
        "Nous n'avons pas pu déterminer le quota de journaux du clinicien concerné. Associez ce secrétaire à un clinicien, ou envoyez l'invitation en étant connecté en tant que ce clinicien.",
    noTemplateSelected: "Aucun modèle sélectionné. Veuillez d'abord",
    createTemplate: "créer un modèle",
    createTemplateFirst: ".",
    organisation: "Organisation",
    hospitalNumberOptional: "Numéro de dossier hospitalier (facultatif)",
    enterNhsHospitalNumber: "Saisir le numéro de dossier hospitalier NHS",
    hospitalNumberDescription: "Permet de retrouver ce patient dans vos dossiers hospitaliers.",
    referenceDateLabel: "Date de départ des suivis",
    referenceDateStartToday: "Commencer aujourd'hui",
    referenceDateAskPatient: "Le patient l'indique",
    inviteMethodLabel: "Comment le patient reçoit son invitation",
    inviteMethodSend: "Envoyer un e-mail ou un SMS",
    inviteMethodShare: "Afficher un code QR ou copier un lien",
    selectOrganisationToContinue: "Sélectionnez une organisation pour continuer.",
    selectContactToContinue: "Sélectionnez une personne de contact pour continuer.",
    doctorEmailSharedWithPatient:
        "Cet e-mail est partagé avec le patient ; soyez donc prudent avant de le communiquer ou de l'utiliser ici.",
    currentUserEmailSharedWithPatient:
        "Votre e-mail sera partagé avec les patients et mis en copie de leurs communications. Nous vous conseillons d'ajouter une adresse d'aide générique, comme la boîte e-mail du service, comme personne de contact.",
    addContactPerson: "Ajouter une personne",
    personalContactEmailWarning: "Cet e-mail semble personnel et les patients le verront.",
    personalContactEmailAddContact: "Ajoutez un contact générique",
    personalContactEmailAfterLink: "comme info@clinic.com depuis la page Équipe ; c'est gratuit.",
    enterPhoneNumber: "Saisir le numéro de téléphone",
    backToSetup: "Retour à la configuration",
    backToPatients: "Retour aux patients",
    patientInvite: "Invitation du patient",
    diaryQrCode: "Code QR du journal",
    diaryQrDescription:
        "Partagez ce code QR ou ce lien afin que les patients puissent s'inscrire sur leur téléphone et commencer ce journal. Les détails de configuration ont été confirmés à l'étape précédente.",
    generatingInviteLink: "Génération du lien d'invitation…",
    failedToCreateInviteLink: "Échec de la création du lien d'invitation",
    hospitalOnTheInvite: "Établissement figurant sur l'invitation",
    changingOrganisationUpdatesLink: "Toute modification met à jour le lien et le code QR.",
    shownOnPatientSignupLink: "Affiché sur le lien d'inscription du patient.",
    patientWillChooseOrganisation: "Le patient choisira donc son organisation lors de l'inscription.",
    hospitalNumber: "Numéro de dossier hospitalier",
    enterHospitalNumber: "Saisir le numéro de dossier hospitalier",
    requiredForNhsOrganisations: "Affiché pour les organisations qui collectent un numéro de dossier hospitalier",
    copyLink: "Copier le lien",
    copyQrCode: "Copier le code QR",
    copyInviteLink: "Copier le lien d'invitation",
    invitePageTitle: "Inviter",
    roleAndOrganisation: "Rôle et organisation",
    navInviteDescription: "Invitez un clinicien, un patient ou un secrétaire sur Patient Watch.",
    tabEmail: "E-mail",
    tabQrCode: "Code QR",
    optionalSuffix: "(facultatif)",
};
